import type { EditableStateInfo, StoryModel } from 'types/story';
import { StoryFacade } from 'utils/facades/story-facade';
import type { AdminThunkDispatch } from 'admin/reducers';
import { bindEditorWrites } from 'admin/components/pages/Story/StoryEditorChat/bind-editor-writes';

type RefreshEditedCardParams = {
	story: StoryModel;
	cardId: string;
	editableState: () => EditableStateInfo;
};

/** Refreshes the open card from `story`, without autosave; returns false when the card no longer exists. */
export function refreshEditedCard(
	dispatch: AdminThunkDispatch,
	{ story, cardId, editableState }: RefreshEditedCardParams
): boolean {
	const { latest } = story.storyVersions;
	const { card } = StoryFacade.findCardInSteps(cardId, latest.data.steps);
	if (!card) return false;

	bindEditorWrites(dispatch, editableState).updateEditableCardData({
		type: 'full',
		disableSync: true,
		value: {
			data: card,
			storySettings: latest.settings,
			storyElements: latest.data.elements,
			symbols: latest.data.symbols ?? {},
		},
	});
	return true;
}
